import isEqualImpl from 'lodash/isEqual'

// TODO maybe should be generic?
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isEqual = (a: any, b: any) => isEqualImpl(a, b)
